export { default as MapInsertInspection } from './MapInsertInspection';
